import React from 'react';
import styled from 'styled-components';

const StyledBtn = styled.button`
  background-color: transparent;
  padding: 0;
  margin: 0;
  border: none;
  cursor: pointer;
`

export default StyledBtn;